import Layout from './Layout';
import AdminPage from './pages/AdminPage';
import { APPS } from '@/commons/constants/apps';
import { roles } from '@transfeeradev/api-enums';
import loggedUser from '@/commons/resources/loggedUser';
import appSettingsResource from '@/apps/payments/resources/settings';

export default {
  path: APPS.MY_COMPANY.path,
  component: Layout,
  name: 'Admin',
  meta: {
    allowForRoles: roles.appRoles.ADMIN
  },
  redirect: {
    name: 'AdminCompanyDataPage'
  },
  children: [
    {
      path: 'dados-da-empresa',
      name: 'AdminCompanyDataPage',
      component: AdminPage
    },
    {
      path: 'usuarios',
      name: 'AdminUsersPage',
      component: AdminPage
    },
    {
      path: 'faturas',
      name: 'BillingPage',
      component: AdminPage,
      meta: {
        async beforeEnter() {
          if (!loggedUser.isAdmin()) {
            return {
              name: 'AdminCompanyDataPage'
            };
          }

          const { showFinanceInfo } = await appSettingsResource.get();

          if (!showFinanceInfo) {
            return { name: 'AdminCompanyDataPage' };
          }
        }
      }
    },
    {
      path: 'limites',
      name: 'AdminLimitsPage',
      component: AdminPage
    }
  ].map(route => ({
    ...route,
    meta: {
      ...route.meta,
      authAs: [APPS.PAYMENTS.key, APPS.CONTACERTA.key]
    }
  }))
};
